if (typeof(ef_pwIcon) != "undefined" && ef_pwIcon != null) {

  const ef_pwIcon = document.querySelector(".ef-form-item--password .ef-form-item__icon");
  const ef_pwField = document.querySelector(".ef-form-item--password .ef-form-item__field");
  ef_pwIcon.classList.add("--pw-hidden");

  function ef_togglePassword() {
    if (ef_pwField.type === "password") {
      ef_pwField.type = "text";
      ef_pwIcon.classList.remove("--pw-hidden");
      ef_pwIcon.classList.add("--pw-visible");
    } else {
      ef_pwField.type = "password";
      ef_pwIcon.classList.add("--pw-hidden");
      ef_pwIcon.classList.remove("--pw-visible");
    }
  }

  ef_pwIcon.addEventListener("click", ef_togglePassword);
}
